module.exports = __webpack_public_path__ + "static/media/do.91ba81b2.png";